import type React from 'react';

interface NewLogoBlackIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function NewLogoBlackIcon({ size = 24, ...props }: NewLogoBlackIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17700_115363)">
        <path
          d="M11.9715 7.25291C13.9214 7.25291 15.5022 5.65686 15.5022 3.68804C15.5022 1.71922 13.9214 0.123169 11.9715 0.123169C10.0215 0.123169 8.44073 1.71922 8.44073 3.68804C8.44073 5.65686 10.0215 7.25291 11.9715 7.25291Z"
          fill="currentColor"
        />
        <path
          d="M15.3059 13.662L2.29357 0.523857C1.44742 -0.330475 6.10352e-05 0.275145 6.10352e-05 1.48217V14.5374C6.10352e-05 15.2217 0.549779 15.7754 1.22614 15.7754H2.96019C3.63794 15.7754 4.18627 15.2203 4.18627 14.5374V11.5487L8.01342 15.4128C8.24305 15.6447 8.55479 15.7754 8.88044 15.7754H14.4375C15.5299 15.7754 16.0769 14.4419 15.3045 13.662H15.3059Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17700_115363">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
